import { motion } from 'framer-motion'

import { LittleText, SubTitle } from '@/components/common/UI'
import { Icons } from '@/components/icons'
import { Card, CardBody } from '@/components/nextui'
interface TipsProps {
    title?: string
    time: string
    className?: string
}
export const TimerTips = ({
    time,
    title,
    className
}: TipsProps): JSX.Element => {
    return (
        <motion.article
            className={`flex justify-center ${className}`}
            initial={{ y: -50, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 1, ease: 'easeOut' }}
        >
            <Card>
                <CardBody>
                    <LittleText text={title || ''} />
                    <div className="flex items-center gap-3 pt-3 justify-center">
                        <SubTitle
                            subTitle={time}
                            className="text-primary"
                        />
                        <Icons.Clock className="text-primary" />
                    </div>
                </CardBody>
            </Card>
        </motion.article>
    )
}
